<template>
  <div class="edu">
    <breadcrumb></breadcrumb>
    <div class="edu-content">
      <div class="state-list">
        <span>
          <span
            class="state"
            @click="changeState(i.value)"
            :class="form.activeStatus === i.value ? 'active' : ''"
            v-for="i in resOptions.stateList"
            :key="i.value"
            >{{ i.name }}</span
          >
        </span>
        <div class="fr">
          <el-button
            v-if="power(userInfo.menuInfoList, 'train-export')"
            type="primary"
            class="el-icon-upload2"
            size="small"
            style="margin-right: 10px"
            @click="toExport"
            >导出</el-button
          >
          <el-dropdown @command="onAddTrain">
            <el-button
              type="primary"
              v-if="$power('train-addActive')"
              class="el-icon-plus"
              size="small"
            >
              新增培训<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="editTrain">校内培训</el-dropdown-item>
              <el-dropdown-item command="editExtraTraining"
                >校外培训</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="isAdmin"
            type="primary"
            class="el-icon-plus"
            size="small"
            style="margin-left: 10px"
            @click="toExamineAuth"
            >审核</el-button
          >
        </div>
      </div>
      <div class="search-list">
        <span>
          <span>培训类型</span>
          <dic-code-selector
            style="margin: 0px 10px"
            @change="query"
            dicType="trainLevel"
            v-model="form.classify3"
          ></dic-code-selector>
          <el-date-picker
            style="margin-right: 10px"
            size="small"
            v-model="form.queryDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="query"
          ></el-date-picker>
          <school-year-selector
            style="margin-right: 10px"
            v-if="form.activeStatus == 2"
            v-model="form.schoolYear"
            @change="query"
          ></school-year-selector>
          <school-term-selector
            style="margin-right: 10px"
            v-if="form.activeStatus == 2"
            v-model="form.schoolTerm"
            @change="query"
            :checkAll="false"
          ></school-term-selector>
          <el-select
            size="small"
            v-model="form.groupCode"
            placeholder="请选择教研组"
            clearable
            @change="query"
            style="margin-right: 10px; width: 200px"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.groupCode"
              :label="item.groupName"
              :value="item.groupCode"
            ></el-option>
          </el-select>
          <el-checkbox-group
            @change="query"
            v-model="form.checkIsMe"
            class="check-me"
          >
            <el-checkbox label="1">我参与的</el-checkbox>
            <el-checkbox label="0">我发布的</el-checkbox>
          </el-checkbox-group>
        </span>
        <el-input
          class="input-length"
          size="small"
          placeholder="搜索培训名称"
          style="width: 250px"
          v-model="form.keyword"
          clearable
          ><el-button
            slot="append"
            type="primary"
            class="search-btn"
            size="small"
            @click="query"
            >搜索</el-button
          ></el-input
        >
      </div>
      <div class="data-list" v-loading="pageLoading">
        <card-list
          moduleType="train"
          :dataList="dataList"
          @delSuccess="query"
        ></card-list>
        <!-- 分页 -->
        <pagination
          :pageObj="pageObj"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import CardList from '@/components/common/CardList.vue'
import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
import Pagination from '@/components/Pagination.vue'
import { postData, postJson } from '@/http/fetch.js'
import { fileSaveZip, power } from '@/utils/index.js'
import SchoolTermSelector from '@/components/school/schoolTermSelector.vue'
import schoolYearSelector from '@/components/school/schoolYearSelector.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['userInfo', 'resOptions', 'currentSemester','isAdmin']),
    ...mapGetters(['schoolCodes'])
  },
  components: {
    CardList,
    Breadcrumb,
    Pagination,
    DicCodeSelector,
    schoolYearSelector,
    SchoolTermSelector
  },
  data() {
    return {
      form: {
        schoolYear: null,
        schoolTerm: null,
        actType: 'training',
        activeStatus: 1,
        classify3: '',
        schoolCodes: [],
        groupCode: '',
        // classify2: "",
        checkIsMe: [], //无用
        isMe: '', // 空 全部
        keyword: '',
        operatorId: '',
        pageNum: '',
        pageSize: '',
        queryDate: null
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 8,
        sizeList: [8, 16, 24, 32]
      },
      pageLoading: true,
      dataList: [],
      groupOptions: []
    }
  },
  created() {
    this.form.schoolYear = this.currentSemester.schoolYear
    this.form.schoolTerm = this.currentSemester.schoolTerm
    this.getGroupList()
    this.init()
  },
  methods: {
    toExport() {
      this.pageLoading = true
      postData('/training/exportTrainingInfo', {
        ...this.form,
        queryEndTime: this.form.queryDate ? this.form.queryDate[1] : null,
        queryStartTime: this.form.queryDate ? this.form.queryDate[0] : null,
        schoolYear: this.form.activeStatus == 2 ? this.form.schoolYear : null,
        schoolTerm: this.form.activeStatus == 2 ? this.form.schoolTerm : null
      })
        .then((data) => {
          fileSaveZip(data.url, data.name)
          this.pageLoading = false
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    power,
    async getGroupList() {
      try {
        let { records } = await postJson('/researchGroup/getResearchGroupInfoList', {
          operatorId: this.userInfo.userId,
          schoolCode: this.userInfo.orgCode || this.userInfo.schoolCode,
          pageNum: 1,
          pageSize: -1,
          isAdmin: this.isAdmin / 1
        })
        this.groupOptions = records || []
      } catch (error) {
        console.log('获取教研组列表失败', error)
        this.groupOptions = []
      }
    },
    init() {
      this.selectData()
    },
    async selectData() {
      try {
        this.pageLoading = true
        this.form.operatorId = this.userInfo.userId
        // this.form.schoolCodes = this.schoolCodes;
        this.form.pageNum = this.pageObj.current
        this.form.pageSize = this.pageObj.size
        let { current, total, size, records } = await postJson(
          '/training/getActiveInfoList',
          {
            ...this.form,
            groupCode: this.form.groupCode || null,
            queryEndTime: this.form.queryDate ? this.form.queryDate[1] : null,
            queryStartTime: this.form.queryDate ? this.form.queryDate[0] : null,
            schoolYear:
              this.form.activeStatus == 2 ? this.form.schoolYear : null,
            schoolTerm:
              this.form.activeStatus == 2 ? this.form.schoolTerm : null
          }
        )
        this.pageObj.total = total
        this.dataList = records
        this.pageLoading = false
      } catch (err) {
        console.log('err', err)
      }
    },
    changeState(code) {
      this.pageObj.current = 1
      this.pageObj.size = 8
      this.form.activeStatus = code
      this.selectData()
    },
    toPathAdd() {
      sessionStorage.removeItem('actCode')
      this.$router.push('editTrain')
    },
    toExamineAuth() {
      this.$router.push('extraTrainingTeacher')
    },
    onAddTrain(command) {
      sessionStorage.removeItem('actCode')
      this.$router.push(command)
    },
    query() {
      this.pageObj.current = 1
      this.selectData()
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.current = 1
      this.pageObj.size = pageSize
      this.selectData()
    },
    handleCurrentChange(curPage) {
      this.pageObj.current = curPage
      this.selectData()
    }
  },
  watch: {
    'form.checkIsMe': {
      handler(val, oldVal) {
        if (val.length == 1) {
          this.form.isMe = val[0]
        } else {
          this.form.isMe = ''
        }
      }
    }
  }
}
</script>


